import axios from "axios"
export function getScreenLocations(token) {
    return axios.get(process.env.REACT_APP_API_URL + `/getScreenLocations`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}